import { createContext, useContext } from 'react';
import { UnicornApi } from '@cld/unicorn-api';

export const UnicornApiContext = createContext<{ unicornApi?: UnicornApi }>({});

export const useUnicornApiContext = () => {
  const contextValue = useContext(UnicornApiContext);

  if (!contextValue) {
    throw new Error('Missing UnicornApiContext');
  }

  return contextValue;
};
